export default __webpack_public_path__ + "static/media/portfolio-home.295741ef.png";